<div class="consultation-request" *ngIf="!loadingService.isLoading">
  <div class="container consultation-request-container" *ngIf="errorMessage">
    <div class="columns is-centered mx-0">
      <div class="column is-10">
        <div class="my-4">
          <app-error-notification classes="is-fullwidth notification-error p-3 has-text-black mb-5">
            <p class="is-inline" [innerHTML]="errorMessage"></p>
          </app-error-notification>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!errorMessage">
    <app-consultation-request-header></app-consultation-request-header>
    <div class="container consultation-request-container mt-2" data-qa-id="Dynamic Consultation Request Form">
      <div class="columns is-centered mx-0">
        <div class="column is-10 pt-0" id="consultation-request-container">
          <div class="my-4">
            <app-consultation-request-patient-info
              [patientInfoForm]="patientInfoForm"
            ></app-consultation-request-patient-info>
          </div>
          <div class="my-4">
            <app-consultation-request-choose-a-pharmacy
              *ngIf="displayChooseAPharmacyComponent"
              #chooseAPharmacyComponent
              [pharmacyForm]="pharmacyForm"
              [zipcode]="consultationRequestOrder?.address.customer_address_zip"
              [pharmacy]="preselectedPharmacy"
            ></app-consultation-request-choose-a-pharmacy>
          </div>
          <div *ngIf="isUtiTreatmentType" class="my-4">
            <app-consultation-request-treatment-preferences-card
              [form]="treatmentPreferencesForm"
              [tests]="consultationRequestOrder?.tests"
            ></app-consultation-request-treatment-preferences-card>
          </div>
          <div class="my-4">
            <app-card
              title="Medical Questionnaire"
              headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title"
              contentClasses="p-4"
            >
              <app-dynamic-questionnaire-form
                data-qa-id="Medical Questions Form"
                #medicalQuestionsForm
                *ngIf="medicalQuestionIds.length"
                [storageKey]="consultationRequestTreatmentType"
                [indexedDbName]="indexedDbName"
                [questionIds]="medicalQuestionIds"
                [externalData]="externalData"
              ></app-dynamic-questionnaire-form>
              <app-medical-history-questions
                #medicalHistoryQuestionsForm
                [allergiesDetailsInitialValue]="consultationRequest?.allergies"
                [medicationDetailsInitialValue]="consultationRequest?.prescriptions"
                [otherConditionsDetailsInitialValue]="consultationRequest?.health_info"
              ></app-medical-history-questions>
              <app-consultation-request-address
                [title]="consultationRequestAddressTitle"
                [addressForm]="addressForm"
                [pharmacyState]="pharmacyState"
              ></app-consultation-request-address>
              <app-std-prevention-upgrade-dosage-upsell
                *ngIf="isStdPrevention && stdPreventionTestId"
                #stdPreventionUpgradeDosageUpsell
                [testId]="stdPreventionTestId"
              ></app-std-prevention-upgrade-dosage-upsell>
              <app-dynamic-questionnaire-form
                class="upsell-questions"
                data-qa-id="Upsell Questions Form"
                #upsellQuestionsForm
                *ngIf="upsellIds.length"
                [storageKey]="QuestionnaireStorageKeys.Upsells"
                [questionIds]="upsellIds"
                [externalData]="externalData"
                (showLabFinderModal)="presentLabFinderModal()"
              ></app-dynamic-questionnaire-form>
            </app-card>
          </div>

          <div class="my-4" *ngIf="agreementQuestionIds?.length">
            <app-card headerClasses="is-hidden" contentClasses="p-4 terms-background">
              <app-dynamic-questionnaire-form
                data-qa-id="Agreement Questions Form"
                #agreementQuestionsForm
                [storageKey]="QuestionnaireStorageKeys.AgreementQuestions"
                [questionIds]="agreementQuestionIds"
                [externalData]="externalData"
              ></app-dynamic-questionnaire-form>
            </app-card>
          </div>
          <div class="my-4">
            <p
              *ngIf="shouldDisplayBottomError"
              data-qa-id="Questionnaire Continue Button Error"
              class="has-text-centered has-text-weight-ultrabold mb-3 has-text-danger"
            >
              {{ submissionError || responseError }}
            </p>
            <button
              (click)="continue()"
              class="continue-button button is-rounded is-primary"
              data-qa-id="Questionnaire Continue Button"
              [disabled]="isProcessing || continueErrorMessage"
            >
              <i *ngIf="isProcessing" class="fa fa-spin fa-spinner"></i>
              <span *ngIf="!isProcessing">Continue</span>
            </button>
            <p
              data-qa-id="Continue Button Error Message"
              *ngIf="continueErrorMessage"
              class="has-text-danger has-text-centered mt-3"
            >
              {{ continueErrorMessage }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<app-lab-finder-modal
  *ngIf="showLabFinderModal"
  [(active)]="showLabFinderModal"
  data-qa-id="Lab Finder Modal"
  searchDescription="To find the nearest lab for your test, please enter your zip code below. These labs do not require an appointment."
></app-lab-finder-modal>
